import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import { useInstance, onBeforeMount } from 'intact-vue';
export function useExpanded(getNodes) {
  var instance = useInstance();
  var expandedKeys = new _Set();
  instance.on('$receive:expandedKeys', function (v) {
    expandedKeys = new _Set(v);
  });
  onBeforeMount(function () {
    /**
     * change the behavior
     * if the data is undefined, we expand all keys after we received data
     */
    var _instance$get = instance.get(),
      defaultExpandAll = _instance$get.defaultExpandAll,
      data = _instance$get.data;
    if (defaultExpandAll) {
      if (data && data.length) {
        expandAll();
      } else {
        instance.on("$receive:data", function cb() {
          expandAll();
          instance.off("$receive:data", cb);
        });
      }
    }
  });
  function toggle(_x) {
    return _toggle.apply(this, arguments);
  }
  function _toggle() {
    _toggle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
      var _instance$get3, load, key, expanded;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _instance$get3 = instance.get(), load = _instance$get3.load;
            key = node.key;
            expanded = expandedKeys.has(key);
            if (!(load && !expanded && !node.loaded)) {
              _context.next = 9;
              break;
            }
            node.loaded = false;
            instance.forceUpdate();
            _context.next = 8;
            return load(node);
          case 8:
            node.loaded = true;
          case 9:
            if (expanded) {
              expandedKeys.delete(node.key);
            } else {
              expandedKeys.add(node.key);
            }
            instance.set('expandedKeys', _Array$from(expandedKeys));
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _toggle.apply(this, arguments);
  }
  function expandAll() {
    var _instance$get2 = instance.get(),
      load = _instance$get2.load;
    var loop = function loop(nodes) {
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!load || node.loaded) {
          expandedKeys.add(node.key);
        }
        if (node.children) {
          loop(node.children);
        }
      }
    };
    loop(getNodes());
    instance.set('expandedKeys', _Array$from(expandedKeys));
  }
  return {
    get: function get() {
      return expandedKeys;
    },
    toggle: toggle,
    expandAll: expandAll
  };
}